<Navbar/>
<div class="row mt-3">
    <div class="col-md-4 d-none d-lg-block">
      <p class="mx-2">{{current_date}}</p>
    </div>
    <div class="col-12 col-sm-12 col-md-4 text-lg-center">
       <h3 class="underline-heading">{{$route.params.portal_name}}.</h3>
    </div>
    <div class="col-6 col-sm-6 col-md-4 d-none d-lg-block">
    <div class="d-flex float-end px-3">
        <p class="">
            <i class="bx bx-command fs-4" data-bs-toggle="offcanvas" href="#all_portals" role="button" aria-controls="all_portals"></i>
        </p>
        
    </div>
    </div>

</div>

<!-- Tab Contents -->
<div class="tab-content mt-3">
  <!-- Your Feed -->
  <div v-if="activeVoiceTab === 'your_feed'">
    <div class="row mt-2 px-2">
      <div class="col-md-12 mb-2 px-0 px-lg-5" v-for="report in reports">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <p class="text-xs">{{report.publication_date}} </p>
          <div>
            <i class="bi bi-person-circle fs-6">{{report.creater.first_name}} {{report.creater.last_name}}</i>
          </div>
          <div>
             <div class="mb-3 me-2 menu mt-1" @click.stop>
                      <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open" name="menu-open" />
                      <span><label :for="'menu-open-' + report.id" class="menu-open-button text-xs color-purple d-flex"
                          @click="boon"><i class="bi bi-share"></i><span
                            class="color-purple mx-1 ">Share</span></label></span>

                      <a @click="copyReportLinkToClipboard(report)" class="menu-item ">
                        <span @click="closeMenu(report.id)"><i
                            class="bi bi-link fs-4 copy text-primary text-xxs"></i></span>
                      </a>

                      <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item facebook-share-btn" @click="closeMenu(report.id)">
                        <i class="bi bi-facebook"></i>
                      </a>
                      <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item twitter-share-btn" @click="closeMenu(report.id)">
                        <i class="bi bi-twitter-x"></i>
                      </a>
                      <a :href="'mailto:?subject=Check%20this%20out&body=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item gmail-share-btn" @click="closeMenu(report.id)">
                        <i class="bi bi-google"></i>
                      </a>
                      <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item linkedin-share-btn" @click="closeMenu(report.id)">
                        <i class="bi bi-linkedin "></i>
                      </a>
                      <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item whatsapp-share-btn" @click="closeMenu(report.id)">
                        <i class="bi bi-whatsapp "></i>
                      </a>
                      <a :href="'https://t.me/share/url?url=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item telegram-share-btn" @click="closeMenu(report.id)">
                        <i class="bi bi-telegram "></i>
                      </a>

                      <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
                        <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert"
                          aria-live="assertive" aria-atomic="true">
                          <div class="d-flex">
                            <div class="toast-body">
                            </div>
                            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                              aria-label="Close"></button>
                          </div>
                        </div>
                      </div>

                    </div>
          </div>
         </div> 
         <div class="px-0 px-lg-5">
           <div v-for="(fileObj, index) in report.report_files" :key="index" >
                      
                        <img v-if="fileObj.file.file_url.includes('.jpg') ||
                                      fileObj.file.file_url.includes('.png') || 
                                      fileObj.file.file_url.includes('.jpeg')" :src="fileObj.file.file_url"
                          alt="Feed Image" class="img-fluid image-blog w-100"
                        />

                
                        <audio v-else-if="fileObj.file.file_url.includes('.mp3') ||
                                            fileObj.file.file_url.includes('.wav')" controls class="w-100">
                          <source :src="fileObj.file.file_url" type="audio/mp3">
                          Your browser does not support the audio element.
                        </audio>

                        <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls
                          class="img-fluid rounded-5 w-100" @click="display_comment_modal(report)">
                          <source :src="fileObj.file.file_url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>

                        <div v-else class="uploaded-file" @click="display_comment_modal(report)">
                          <img :src="getFileIcon(fileObj.file.file_url)" class="file-icon small-icon" />
                          <span class="file-name">{{ getFileName(fileObj.file.file_url) }}</span>
                          <a :href="fileObj.file.file_url" download :title="getFileName(fileObj.file.file_url)"
                            class="download-btn" @click.stop>
                            <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
                          </a>
                        </div>

          </div>
           <p v-html="report.description" class="text-xs mt-3"></p>

            <div class="d-flex justify-content-between align-items-center ">
                    <div class="mb-3 ms-2 me-3 mt-1">
                      <span class="d-flex color-purple " :id="'like-button' + report.id"
                        @click.stop="likeReport(report)"><i class="bi bi-hand-thumbs-up fw-bold"></i><span
                          class="text-purple text-xs mt-1 mx-1">Like</span></span>
                      <span :id="'liked-button' + report.id" class="d-none d-flex text-primary "
                        @click.stop="unlikeReport(report)"><i class="bi bi-hand-thumbs-up-fill"></i><span
                          class="text-primary text-xs mt-1 mx-1">Unlike</span> </span>
                    </div>

                    <div class="input-group mb-3 me-2 rounded-5 w-100 position-relative mt-1"
                      @click="display_comment_modal(report)">

                      <input type="text" class="form-control text-xs rounded-start rounded-end"
                        placeholder="Write a comment .." readonly>
                    </div>
              </div>
         </div>
            
         <div>
         </div>
      </div>
    </div>
  </div>

  <!-- Voice Tab -->
  <div v-if="activeVoiceTab === 'voice'">
    <SurveyView/>
  </div>

  <!-- Portal Requests Tab -->
  <div v-if="activeVoiceTab === 'requests'">
    <PortalRequest/>
  </div>

  <!-- Documents Tab -->
  <div v-if="activeVoiceTab === 'documents'">
   <DocumentApproval/>
  </div>

  <!-- Warehouse Tab -->
  <div v-if="activeVoiceTab === 'warehouse'">
     <DocumentWarehouse/>
  </div>
</div>


<div class="offcanvas offcanvas-end" tabindex="-1" id="menu_items" aria-labelledby="menu_items_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <AllPortals/>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="all_portals" aria-labelledby="all_portals_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ul class="nav nav-pills publish-tabs justify-content-center" role="tablist">
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'your_feed' }"
          @click="activeVoiceTab = 'your_feed'">
          News & Articles
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'voice' }"
          @click="activeVoiceTab = 'voice'">
          Voice
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'requests' }"
          @click="activeVoiceTab = 'requests'">
          Portal requests
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'documents' }"
          @click="activeVoiceTab = 'documents'">
          Document/Media Approval
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'warehouse' }"
          @click="activeVoiceTab = 'warehouse'">
          Document Warehouse
        </button>
      </li>
    </ul>
  </div>
</div>

<ReportCommentModal v-if="comment_modal_visible" :report_data="report_data"
  @hide_comment_comment="hide_comment_comment" />

 <StickyNav/> 